<button *ngIf="miniFab === false"
        [class]="(classButton ?? '') + (vertical ? ' h-full flex flex-column py-2 px-3 gap-1 ' : '')"
        [color]="color"
        [disabled]="disabled"
        [attr.tabindex]="unfocusable ? '-1' : undefined"
        [ngClass]="{
    'mdc-button' : label !=='',
    'mdc-icon-button mat-mdc-icon-button mat-mdc-button-base': icon && label==='',
    'mat-mdc-button': label !=='' && raised === false,
    'mdc-button--raised mat-mdc-raised-button': raised === true,
    'mdc-button--outlined mat-mdc-outlined-button': outlined === true,
    'w-full': fullWidth === true,
    'border-round-3xl': vertical === false,
    'border-round-xl': vertical === true,
  }" mat-button>

  <mat-icon *ngIf="icon" [fontIcon]="icon" aria-hidden="false" aria-label="Example home icon"
            [class]="'material-symbols-outlined ' + (vertical ? ' ml-0 mr-0 vertical-icon-size ' : '')"></mat-icon>
  <span *ngIf="!icon" class="ml-1"></span>
  <span>{{label}}</span>
</button>
<button *ngIf="miniFab === true" mat-mini-fab [color]="color" [disabled]="disabled" aria-label="fab-button">
  <mat-icon *ngIf="icon" class="material-symbols-outlined">{{icon}}</mat-icon>
</button>
